import styled from "styled-components"
import NotFoundImage from "../assets/undraw_empty.svg"

const NotFoundImageComponent = styled(NotFoundImage)`
  width: 70%;
  height: 600px;
  display: block;
  margin: 0 0 0 auto;
  & *[fill="#6c63ff"] {
    fill: ${(props) => props.theme.b_color_gradients.b_dark};
  }
  @media (max-width: 600px) {
    width: 100%;
  }
`

export { NotFoundImageComponent }
